import { useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Button } from "react-bootstrap";
import { FiSun, FiMoon } from "react-icons/fi";

function NavBar() {
  const [mode, setMode] = useState("light");

  const changeTheme = () => {
    // console.log("Changing theme...");
    if (mode === "light") {
      setMode("dark");
    } else {
      setMode("light");
    }
  };
  // console.log("Mode:", mode);

  return (
    <Navbar 
      // bg="light"
      expand="lg"
      style={{ padding: "1%", "font-size": "17px" }}
      className={`NavBar ${mode}`}
      bg="dark"
      variant="dark"
    >
      <Container>
        <Navbar.Brand href="/"><b>Home</b></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav style={{ "margin-left": "auto" }}>
            <Nav.Link href="blogs"><b>Blog</b></Nav.Link>
            <Nav.Link href="projects"><b>Projects</b></Nav.Link>
            <Nav.Link href="about"><b>About</b></Nav.Link>
            <Nav.Link href="resume"><b>Resume</b></Nav.Link>
            {/* <Button onClick={changeTheme} variant="dark">
              {mode === "light" ? <FiMoon /> : <FiSun />}
            </Button> */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
